import { Form } from "react-bootstrap";

import {
  convertParameter,
  FN_PARAMETER_TYPES,
  FnParameterType,
} from "../playgroundFunctions";
import { FnParameter } from "../../types";

const ParameterTypeSelect = ({
  id,
  parameter,
  onChange,
  "aria-label": ariaLabel,
}: {
  id: string;
  parameter: FnParameter;
  onChange: (next: FnParameter) => void;
  // Names the select where no visible label points at it.
  "aria-label"?: string;
}) => (
  <Form.Select
    id={id}
    className="font-monospace w-auto"
    aria-label={ariaLabel}
    value={parameter.value_type}
    onChange={(event) =>
      onChange(
        convertParameter(parameter, event.target.value as FnParameterType)
      )
    }
    data-testid={id}
  >
    {FN_PARAMETER_TYPES.map((valueType) => (
      <option key={valueType} value={valueType}>
        {valueType}
      </option>
    ))}
  </Form.Select>
);

export default ParameterTypeSelect;
